import React, { useState, useEffect, useRef } from "react";
import { ChevronDown, Ship } from "lucide-react";
import shipIcon from "../../assets/icons/icon-vessel-blue.png";

const FleetHeader = ({
  currentFleet,
  fleets = [],
  onFleetChange,
  pageTitle = "Machinery Analytics",
  isLoading = false
}) => {
  const [showFleetDropdown, setShowFleetDropdown] = useState(false);
  const dropdownRef = useRef(null);
  console.log("FleetHeader - currentFleet:", currentFleet);
  const handleFleetChange = (fleet) => {
    onFleetChange(fleet);
    setShowFleetDropdown(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowFleetDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative group" ref={dropdownRef}>
      <div className="flex items-center gap-3">
        <img src={shipIcon} alt="Ship Icon" className="w-8 h-6" />

        <div className="flex items-baseline gap-2">
          <div className="flex items-center gap-1">
            <button
              onClick={() => setShowFleetDropdown(!showFleetDropdown)}
              className="flex items-center gap-1 group-hover:text-[#18325d] transition-colors"
              disabled={isLoading}
            >
              {/* <span className="text-2xl font-semibold text-[#27ade3]">
                {isLoading ? "Loading..." : currentFleet?.fleetName}
              </span> */}
            <span className="text-2xl font-semibold text-[#27ade3]">
              {isLoading
                ? "Loading..."
                : currentFleet === "all"
                ? "ALL FLEET"
                : currentFleet?.fleetName}
            </span>

              {!isLoading && (
                <ChevronDown
                  className={`w-4 h-4 mt-1 text-[#18325d] transition-transform duration-200 ${showFleetDropdown ? "rotate-180" : ""
                    }`}
                />
              )}
            </button>
          </div>

          <span className="text-gray-300">/</span>

          <span className="text-lg font-bold text-[#18325d]">
            {pageTitle}
          </span>
        </div>
      </div>

      {showFleetDropdown && fleets.length > 0 && (
        // <div className="absolute z-20 mt-3 w-64 bg-white rounded-lg shadow-lg border border-gray-100 overflow-hidden">
        //   <div className="py-1 max-h-60 overflow-y-auto">
        //     {fleets.map((fleet) => (
        //       <button
        //         key={fleet?.fleetId}
        //         className={`w-full text-left px-4 py-2.5 transition-colors duration-150 flex items-center gap-2 ${
        //           fleet === currentFleet
        //             ? "bg-gradient-to-r from-[#27ade3]/10 to-[#2e6bdb]/10 text-[#2e6bdb]"
        //             : "text-gray-700 hover:bg-gray-50/80"
        //         }`}
        //         onClick={() => handleFleetChange(fleet)}
        //       >
        //         <Ship className="w-4 h-4 flex-shrink-0" />
        //         <span className="font-medium truncate">{fleet?.fleetName}</span>
        //       </button>
        //     ))}
        //   </div>
        // </div>
        <div className="absolute z-20 mt-3 w-64 bg-white rounded-lg shadow-lg border border-gray-100 overflow-hidden">
          <div className="py-1 max-h-60 overflow-y-auto">
            {/* Static All Fleet option */}
            <button
              key="all-fleet"
              className={`w-full text-left px-4 py-2.5 transition-colors duration-150 flex items-center gap-2 ${currentFleet === "all"
                  ? "bg-gradient-to-r from-[#27ade3]/10 to-[#2e6bdb]/10 text-[#2e6bdb]"
                  : "text-gray-700 hover:bg-gray-50/80"
                }`}
              onClick={() => handleFleetChange("all")}
            >
              <Ship className="w-4 h-4 flex-shrink-0" />
              <span className="font-medium truncate">ALL FLEET</span>
            </button>

            {/* Dynamic fleet list */}
            {fleets.map((fleet) => (
              <button
                key={fleet?.fleetId}
                className={`w-full text-left px-4 py-2.5 transition-colors duration-150 flex items-center gap-2 ${currentFleet?.fleetId === fleet?.fleetId
                    ? "bg-gradient-to-r from-[#27ade3]/10 to-[#2e6bdb]/10 text-[#2e6bdb]"
                    : "text-gray-700 hover:bg-gray-50/80"
                  }`}
                onClick={() => handleFleetChange(fleet)}
              >
                <Ship className="w-4 h-4 flex-shrink-0" />
                <span className="font-medium truncate">{fleet?.fleetName}</span>
              </button>
            ))}
          </div>
        </div>

      )}
    </div>
  );
};

export default FleetHeader;